import React, { useEffect, useState, useContext } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from "@stripe/react-stripe-js";
import { AccountContext } from '../Accounts';
import { useNavigate } from 'react-router-dom'
import GetStories from './getStories';
// import v1 from '../../videos/v1.mp4';
// import v2 from '../../videos/v2.mp4';
import v3 from '../../videos/v2.mp4';
import PutStories from './putStories';
import {
    LibraryContainer,
    LibraryShelf,
    LibraryButton,
    ShelfTitle,
    BookRow,
    BookThumbnail,
    BookDescription,
    BookTitle,
    BookDetails,
    BookThumbnailImage,
    SpinningIcon
} from './LibraryElements';
// import VideoPlayer from '../VideoPlayer';
import StoryTimeModal from '../StoryTime';
import StoryTellerModal from '../StoryTeller';
// import { BedrockRuntimeClient, InvokeModelWithResponseStreamCommand } from "@aws-sdk/client-bedrock-runtime"
// import { BedrockAgentClient, ListAgentAliasesCommand, ListAgentsCommand, ListKnowledgeBasesCommand } from "@aws-sdk/client-bedrock-agent"
// import RemoveStories from './removeStories';
import RemoveModal from '../RemoveModal';
import GenerateInitialStory from '../BedrockLibrary/TextGeneration';
import StoryMakerModal from '../StoryMaker';
import CheckoutModal from '../CheckoutForms';
import PostRequest from './postAPIRequest';
import ProductPageModal from '../ProductForms';
// import { BedrockClient, ListFoundationModelsCommand } from "@aws-sdk/client-bedrock"
const k = process.env.REACT_APP_K_LIVE
const stripePromise = loadStripe(k)


const MyLibrary = () => {
    // const [videos, setVideos] = useState([{ id: crypto.randomUUID(), video: v1, title: 'Book Title 1', description: "Book Description 1" },
    // { id: crypto.randomUUID(), video: v2, title: 'Book Title 2', description: "Book Description 2" },
    // { id: crypto.randomUUID(), video: v3, title: 'Book Title 3', description: "Book Description 3" },]);
    const [clientSecret, setClientSecret] = useState(null);
    const [status, setStatus] = useState(false);
    const [stories, setStories] = useState([]);
    const [selectedStory, setSelectedStory] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isStoryTellerOpen, setIsStoryTellerOpen] = useState(false);
    const [isStoryMakerOpen, setIsStoryMakerOpen] = useState(false);
    const [removeOpen, setRemoveOpen] = useState(false);
    const [stripeOptions, setStripeOptions] = useState();
    const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);
    const folderPath = 'stories/';
    const navigate = useNavigate();
    const [generatingBoolean, setGeneratingBoolean] = useState(true);
    const { getSession, email } = useContext(AccountContext);
    const [membershipStatus, setMembershipStatus] = useState(false);
    const [intentStatus, setIntentStatus] = useState('');
    const [isProductModalOpen, setProductModalOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState("");
    const [giftStatus, setGiftStatus] = useState(false);
    const [giftDescriptions, setGiftDescriptions] = useState([]);
    const [paidPurchases, setPaidPurchases] = useState([]);
    const [transactions, setTransations] = useState();
    const [currentStory, setCurrentStory] = useState();

    const defaultStoryRequest = {
        id: crypto.randomUUID(),
        title: '',
        setting: '',
        characters: '',
        details: '',
    }

    useEffect(() => {
        getSession()
            .then(session => {
                setStatus(true);
            })
            .catch(err => console.log(err));
    }, [getSession]);

    const checkUserStatus = async () => {
        const storyString = localStorage.getItem('story_time.json');
        const story = JSON.parse(storyString)
        const message = {
            'customerEmail': email
        }
        const request = {
            'requestType': 'UserStatusRequest',
            'request': JSON.stringify(message)
        }
        const response = await PostRequest(request);
        // console.log(response.subscriptionStatus.description, response.subscriptionStatus.active)
        return response
    }

    useEffect(() => {
        const init = async () => {
            if (email) {
                const response = await checkUserStatus();
                if (response) {
                    setMembershipStatus(response.subscriptionStatus.active);
                    setPaidPurchases(response.transactionStatus.paidPurchases)
                    setTransations(response.transactionStatus.allTransactions)
                }
            }
        }
        init()
    }, [email]);

    useEffect(() => {
        const fetchStories = async () => {
            const allStories = await GetStories(folderPath);
            // const updatedStories = allStories.map((story) => ({  All the stories I created before the implementation of the payment process do not have required removed/paidFor fields. This method sets them temporarily if needed. Can map and push using the putStories function if I want to change permenantly.
            //     ...story,
            //     removed: false,
            //     paidFor: true
            //   }));  
            if (membershipStatus) {
                const withoutRemoved = allStories.filter((story, key) => story.removed != true);
                setStories(withoutRemoved);
            }
            else {
                // console.log(allStories.map((story, key) => story.title));
                // const purchasedStories = allStories.filter((story, key) => paidPurchases.includes(story.id));
                // const giftedStories = allStories.filter((story, key) => giftDescriptions.includes(story.id));
                // const filteredStories = [...purchasedStories, ...giftedStories];
                // console.log(filteredStories.map(x => x.id));
                const purchasedStories = allStories.filter((story, key) => story.productType === 'SinglePurchase');
                const giftedStories = allStories.filter((story, key) => story.productType === 'FreeGift');
                const filteredStories = [...purchasedStories, ...giftedStories];
                const withoutRemoved = filteredStories.filter((story, key) => story.removed != true);
                setStories(withoutRemoved);
                if (giftedStories.length === 0) {
                    // console.log("Setting gift status to true", giftedStories.length)
                    setGiftStatus(true)
                }
                setGeneratingBoolean(false)
            }
        };
        fetchStories();
    }, [membershipStatus]);

    const handlePlayback = (videoUrl) => {
        localStorage.setItem('story_time.json', JSON.stringify(defaultStoryRequest))
        // console.log('Playing video: ', videoUrl);
    };

    const handlePurchase = (videoUrl) => {
        // console.log('Purchasing video: ', videoUrl);
    };


    const handleAddNewBook = async (story) => {
        if (status) {
            setGeneratingBoolean(true);
            console.log('Saving new story time details and beginning checkout');
            localStorage.setItem('story_time.json', JSON.stringify(story));
            if (membershipStatus) {
                // console.log('Membership Status', membershipStatus)
                if (selectedProduct === "") {
                    setSelectedProduct('Subscription')
                }
                try {
                    // const newVideo = { video: v2, title: story.title, description: story.details }; // Add appropriate video URL
                    // setVideos([...videos, newVideo]);
                    await GenerateInitialStory(setStories, stories, story, setClientSecret, selectedProduct); // Ensure this is awaited
                    setIsModalOpen(false);
                } catch (error) {
                    console.error('Error generating initial story:', error);
                }
            }
            else {
                try {
                    setCurrentStory(story)
                    setProductModalOpen(true);
                    // console.log(intentStatus);
                    setIsModalOpen(false);
                } catch (error) {
                    console.error('Error in ProductModal:', error);
                }
                setGeneratingBoolean(false);
            }
        } else {
            console.log('User must have an account to save');
            localStorage.setItem('story_time.json', JSON.stringify(story));
            navigate('/signin');
        }
    };


    const handleSaveModifications = (e, story) => {
        e.preventDefault();
        setStories(prevStories => [
            ...prevStories.filter(x => x.id !== story.id),
            story
        ]);
        PutStories(story.id, JSON.stringify(story));
        setSelectedStory(story)
    };

    const handleRemoveModal = (e, story) => {
        // Remove from database ;) would need to uncomment below. 
        e.preventDefault();
        setRemoveOpen(true);
        setSelectedStory(story);
    }

    // const openProductModal = () => {
    //     return new Promise((resolve, reject) => {
    //         setProductModalOpen(true);

    //         // Add an event listener for the custom event
    //         const handleModalClose = (event) => {
    //             // Get the selected product from the event detail
    //             const selectedProduct = event.detail;

    //             // Remove the event listener after it's called to avoid memory leaks
    //             window.removeEventListener('modalClose', handleModalClose);

    //             // Set the selected product state
    //             // setSelectedProduct(selectedProduct);

    //             // Resolve the promise
    //             resolve();
    //         };

    //         // Add the event listener to handle modal close
    //         window.addEventListener('modalClose', handleModalClose);
    //     });
    // };



    const handleSetSelectedProduct = async (e, product) => {
        e.preventDefault();
        setSelectedProduct(product);
        if (product !== 'FreeGift') {
            if (!clientSecret) {
                determineClientSecret(email, product)
            }
            else {
                console.log("CS is Defined")

            }

            setIsCheckoutOpen(true)
        }
        else {
            try {
                console.log("Starting Digital Book Generation")
                setGeneratingBoolean(true);
                setProductModalOpen(false);
                await GenerateInitialStory(setStories, stories, currentStory, setClientSecret, 'FreeGift'); // Ensure this is awaited
                setGiftStatus(false);
                setGeneratingBoolean(false);
            } catch (error) {
                console.error('Error generating initial story:', error);
                setGeneratingBoolean(false);
            }
        }
        // // Dispatch the custom event with the selected product
        // const event = new CustomEvent('modalClose', { detail: product });
        // window.dispatchEvent(event);
    }

    const determineClientSecret = async (email, product) => {
        // console.log(email, product)
        const storyString = localStorage.getItem('story_time.json');
        const story = JSON.parse(storyString)
        const message = {
            'customerEmail': email,
            'itemId': story.id
        }
        const request = {
            'requestType': product,
            'request': JSON.stringify(message)
        }
        const response = await PostRequest(request);
        // console.log(response.clientSecret)
        const options = { clientSecret: response.clientSecret, appearance: { theme: 'stripe', }, loader: 'auto', };
        setStripeOptions(options)
        setClientSecret(response.clientSecret)
    }

    const handleAddPurchasedBook = async (status) => {
        if (status === 'succeeded') {
            // console.log(intentStatus)
            console.log("Building")
            setGeneratingBoolean(true);
            setIsCheckoutOpen(false);
            try {
                console.log("Starting Digital Book Generation")
                await GenerateInitialStory(setStories, stories, currentStory, setClientSecret, selectedProduct); // Need selected product here since it could be new sub or digital book
            } catch (error) {
                console.error('Error generating initial story:', error);
            }
            setGeneratingBoolean(false);
        }
        else {
            console.log("Purchase status unsuccessful")
            setIsCheckoutOpen(false);
        }
    }

    // const handleRemove = (e, story) => { This method actually removes the story from the database and thus makes it unrecoverable
    //     setRemoveOpen(false);
    //     setStories(stories.filter(x => x.id !== story.id))
    //     RemoveStories(story.id)
    // }

    const handleRemove = (e, story) => {
        setRemoveOpen(false);

        if (story) {
            console.log('updating stories');
            const updatedStory = { ...story, removed: true };

            // Update the stories list
            setStories(stories.filter(x =>
                x.id !== story.id
            ));

            // console.log(updatedStory.removed);

            // Update the story in the database
            PutStories(story.id, JSON.stringify(updatedStory));
        }
    };


    const handleStoryModal = (e, story) => {
        e.preventDefault();
        setSelectedStory(stories.filter(st => st.id === story.id)[0])
        setIsStoryTellerOpen(true)
    }

    const handleEditModal = (e, story) => {
        e.preventDefault();
        setSelectedStory(stories.filter(st => st.id === story.id)[0])
        setIsStoryMakerOpen(true)
    }

    return (
        <LibraryContainer className="story-library">
            <LibraryShelf>
                <ShelfTitle>My Library</ShelfTitle>
                {status ? (
                    <>
                        <BookRow className="story-item">
                            <BookDescription className="story-details">
                                <BookTitle>Create something new</BookTitle>
                                <BookDetails>Click below to start building your story.</BookDetails>
                                <LibraryButton onClick={() => setIsModalOpen(true)}>Create Story</LibraryButton>
                            </BookDescription>
                        </BookRow>
                        {generatingBoolean ? (
                            <BookRow className="story-item">
                                <BookThumbnail src={v3} playsInline autoPlay loop muted alt="story Thumbnail" className="video-thumbnail" />
                                <BookDescription className="story-details">
                                    <BookTitle>Updating Library</BookTitle>
                                    <SpinningIcon />
                                </BookDescription>
                            </BookRow>
                        ) : <></>
                        }
                        {
                            stories.length > 0 ? (
                                stories.map((story, index) => (
                                    <BookRow key={index} className="story-item">
                                        {story.img ? <BookThumbnailImage src={story.img} />
                                            : (
                                                <BookThumbnail src={v3} playsInline autoPlay loop muted alt="story Thumbnail" className="video-thumbnail" />
                                            )}
                                        <BookDescription className="story-details">
                                            <BookTitle>{story.title}</BookTitle>
                                            <BookDetails>{story.description}</BookDetails>
                                            <LibraryButton onClick={(e) => handleEditModal(e, story)}>Edit</LibraryButton>
                                            <LibraryButton onClick={(e) => handleStoryModal(e, story)}>Play</LibraryButton>
                                            <LibraryButton onClick={(e) => handleRemoveModal(e, story)}>Remove</LibraryButton>
                                        </BookDescription>
                                    </BookRow>
                                ))
                            ) : (
                                <></>
                            )
                        }
                    </>
                ) :
                    <>
                        <BookRow className="story-item">
                            <BookDescription className="story-details">
                                <BookTitle>Create your first Story</BookTitle>
                                <LibraryButton onClick={() => setIsModalOpen(true)}>Create Story</LibraryButton>
                            </BookDescription>
                        </BookRow>
                        {generatingBoolean ? (
                            <BookRow className="story-item">
                                <BookThumbnail src={v3} playsInline autoPlay loop muted alt="story Thumbnail" className="video-thumbnail" />
                                <BookDescription className="story-details">
                                    <BookTitle>Updating Library</BookTitle>
                                    <SpinningIcon />
                                </BookDescription>
                            </BookRow>
                        ) : <></>
                        }
                    </>
                }
            </LibraryShelf>
            <StoryTimeModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSave={handleAddNewBook} />
            {currentStory && (
                <ProductPageModal isOpen={isProductModalOpen} onClose={() => setProductModalOpen(false)} setSelectedProduct={handleSetSelectedProduct} gift={giftStatus} />
            )}
            {clientSecret && (
                <Elements options={stripeOptions} stripe={stripePromise}>
                    <CheckoutModal isOpen={isCheckoutOpen} onClose={() => setIsCheckoutOpen(false)} setProductModal={setProductModalOpen} clientSecret={clientSecret} setIntentStatus={setIntentStatus} handleAddNewPurchase={handleAddPurchasedBook} />
                </Elements>
            )}
            <StoryMakerModal isOpen={isStoryMakerOpen} onClose={() => setIsStoryMakerOpen(false)} onSave={handleSaveModifications} story={selectedStory} firstPage={0} />
            <StoryTellerModal isOpen={isStoryTellerOpen} onClose={() => setIsStoryTellerOpen(false)} story={selectedStory} firstPage={0} />
            <RemoveModal isOpen={removeOpen} onClose={() => setRemoveOpen(false)} onDelete={handleRemove} story={selectedStory} />
        </LibraryContainer>
    );
};

export default MyLibrary;
